// LiveAgent domain slice — the module's own state (relocated out of store/slices in Seq
// C.4: a domain block that does not own its state is not a block). The orchestrator still
// composes it into the single combined store via combineSlices, so state stays FLAT and
// every existing selector is unchanged.
//
// It holds the reactive face of the Sprinklr live-agent lifecycle, and is the single
// source of truth for escalation; the `maa-live-agent` localStorage record is its
// persisted projection (for reload survival). (Renamed from "conversationSlice": the
// actual message conversation is messagesSlice — this slice is the live-agent session.)
//
// This slice is where the two live-agent facts become reactive, and both are written
// straight here by the block itself — there is no provider effect-bridge (WS-4.2).
//
// `isAgentConnected` is the OBSERVED fact ("the SDK + a conversation are live"). It is not
// React state anywhere: the engine keeps an instance field for its own synchronous reads and
// publishes here for the UI. It deliberately does NOT cross the block boundary — the flows ask
// only about intent and the block reconciles (Seq F.c). (`isAgentInitializing` used to live
// here too and was deleted: nothing ever read it. The visible "connecting to an agent" state is
// a system MESSAGE that updateConnectingToConnected promotes on success, not a store flag.)
//
// `isEscalated` is the persisted INTENT ("messages should route to Sprinklr"). The engine writes
// it through the `setEscalated` action on every transition and on init (hydrating from the
// persisted record), so flows read store.getState().isEscalated as the fresh, single source
// with no ref-bridge.
//
// `surveyOverlayUrl` is folded in here (was its own surveyOverlaySlice, mislabeled
// "Shell"): the post-conversation survey is a live-agent concern — its URL arrives on a
// Sprinklr survey message. The Shell owns *rendering* the overlay; LiveAgent owns the
// *state*. null when hidden; the block's open/close handlers set it.
export const liveAgentSlice = (set) => ({
  isEscalated: false,
  isAgentConnected: false,
  setIsEscalated: (value) => set({ isEscalated: value }, 'setIsEscalated'),
  setIsAgentConnected: (value) => set({ isAgentConnected: value }),
  surveyOverlayUrl: null,
  setSurveyOverlayUrl: (url) => set({ surveyOverlayUrl: url }),
});
